module.exports = __webpack_public_path__ + "img/modal-document-confirm.e256340f.svg";